import { Banner, LoadingWand } from '@ordr-as/umami-react'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { getPaymentStatus } from '../api/paymentApi'
import { useRequest } from '../api/utils'
import Container from '../components/layout/Container'
import {
    useLogProcessPaymentGetPaymentStatus,
    useLogProcessPaymentRedirectToReturnUrl,
    useLogProcessPaymentRedirectToRedirectUrl,
    useLogProcessPaymentLoadPage,
    useLogProcessPaymentPaymentStatusPollingLimitReached,
} from '../utils/analytics'
import { base64Decode } from '../utils/stringUtils'

const ProcessPayment = () => {
    const [searchParams] = useSearchParams()
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const paymentReference = searchParams.get('paymentReference')!
    const encodedRedirectUrl = searchParams.get('redirectUrl')
    const redirectResult = searchParams.get('redirectResult')
    const redirectUrl = encodedRedirectUrl && base64Decode(encodedRedirectUrl)

    // Analytics
    const logPageLoaded = useLogProcessPaymentLoadPage()
    const logGetPaymentStatus = useLogProcessPaymentGetPaymentStatus()
    const logRedirectToReturnUrl = useLogProcessPaymentRedirectToReturnUrl()
    const logRedirectToRedirectUrl = useLogProcessPaymentRedirectToRedirectUrl()
    const logPaymentStatusPollingLimitReached = useLogProcessPaymentPaymentStatusPollingLimitReached

    useEffect(() => {
        logPageLoaded(paymentReference, redirectResult)

        if (redirectUrl) {
            logRedirectToRedirectUrl(paymentReference)
            window.location.href = redirectUrl
        }

        if (redirectResult) {
            getPaymentStatusAndReturn(setTimeout(() => null, 0))
        }

        startPolling()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const startPolling = () => {
        let pollingAttempts = 0
        const id = setInterval(() => {
            pollingAttempts += 1

            // We poll for 1 minute (12 attempts with 5 seconds in between)
            if (pollingAttempts > 12) {
                logPaymentStatusPollingLimitReached()
                setErrorMessage('Oops! An error occured when trying to find out what happened to your payment.')
                clearInterval(id)
                return
            }

            getPaymentStatusAndReturn(id)
        }, 5000)
    }

    const getPaymentStatusAndReturn = (id: NodeJS.Timeout) => {
        logGetPaymentStatus(paymentReference)

        callGetPaymentStatus().then((result) => {
            const hasPaymentResult = result?.returnUrl && result?.isPaymentResultAvailable
            if (hasPaymentResult) {
                logRedirectToReturnUrl(paymentReference)
                window.location.href = result.returnUrl!
                clearInterval(id)
            }
        })
    }

    const { run: callGetPaymentStatus, error: paymentStatusError } = useRequest(() =>
        getPaymentStatus(paymentReference, redirectResult)
    )

    const error = errorMessage || paymentStatusError

    return (
        <Container>
            {!error ? (
                <div className="text-center flex h-screen">
                    <div className="m-auto">
                        <LoadingWand className="-mt-9 mx-auto" />
                        <h1 className="mt-5">Processing payment...</h1>
                    </div>
                </div>
            ) : (
                <>
                    <h1>Process payment</h1>
                    <Banner kind="error" onClose={() => null} stretch="parent" className="my-3">
                        {errorMessage ?? paymentStatusError?.message}
                    </Banner>
                </>
            )}
        </Container>
    )
}

export default ProcessPayment
